module.exports = "/_next/static/images/2a5663d62fd920596c5701efbc82b274-security-desktop.jpg.webp";